const {
  setError, setSuccess, setInfo, clear,
} = require('./actionCreator');

export const showErrorNotification = (message) => (dispatch) => {
  try {
    dispatch(setError(message));
  } catch ({ message: error }) {
    console.log(error);
  }
};

export const showSuccessNotification = (message) => (dispatch) => {
  try {
    dispatch(setSuccess(message));
  } catch ({ message: error }) {
    console.log(error);
  }
};

export const showInfoNotification = (message) => (dispatch) => {
  try {
    dispatch(setInfo(message));
  } catch ({ message: error }) {
    console.log(error);
  }
};

export const clearNotifications = (message) => (dispatch) => {
  try {
    dispatch(clear(message));
  } catch ({ message: error }) {
    console.log(error);
  }
};
